// src/sampleData.js (or a similar path in your project)

export const SAMPLE_TASK_TEMPLATES = [
  {
    name: "Welcome & Basic Navigation",
    notes:
      "This app helps you organize! These samples demo features. Feel free to edit, complete, or delete them. New tasks might be highlighted.",
    isNew: true,
    children: [
      {
        name: "Basics: Adding Tasks",
        notes:
          "Add main tasks via the input field. Subtasks, like this one, help break down work.",
        isNew: true,
      },
      {
        name: "Basics: Completing Tasks",
        notes: "Click the checkbox to mark tasks done. Try it!",
        isNew: true,
      },
      {
        name: "Basics: Viewing Task Details",
        notes:
          "Click any task's title to see more options (notes, deadlines, etc.).",
        isNew: true,
      },
    ],
  },
  {
    name: "Working with Task Details",
    notes:
      "Open tasks to see all options. Many features can be toggled in Settings.",
    isNew: true,
    children: [
      {
        name: "Add Rich Notes (if 'Use Notes' is enabled)",
        notes:
          "This is a sample note! If the 'Use Notes' setting is on, you'll find a notes section in task details for extra info, links, or reminders.",
        isNew: true,
      },
      {
        name: "Set a Deadline & See Countdown",
        hasDeadline: true,
        notes:
          "Assign due dates in task details. This task is due soon! A countdown might appear if the feature is active.",
        isNew: true,
        // 'deadline' property will be set dynamically when samples are generated
      },
      {
        name: "Assign Priority (1-5) (if 'Use Priority' is enabled)",
        priority: 1,
        notes:
          "Make important items stand out! If 'Use Task Priority' is on in Settings, assign a priority (1=Highest). This task is #1.",
        isNew: true,
      },
      {
        name: "This is a Rest Task",
        isRest: true,
        duration: 300, // 5 minutes
        notes:
          "Schedule breaks using 'Rest' tasks. They might have a different appearance or behavior. Default duration for this is 5 min.",
        isNew: true,
      },
    ],
  },
  {
    name: "Organizing with Tags & Multiple Lists",
    isNew: true,
    children: [
      {
        name: "Use Tags for Context (if 'Use Tags' is enabled)",
        tags: ["#getting_started", "#example_tag"],
        notes:
          "If 'Use Tags' is on, tag tasks (like this one with #getting_started, #example_tag) to categorize and filter. Manage available tags in Settings.",
        isNew: true,
      },
      {
        name: "Explore Different To-Do Lists (if available)",
        notes:
          "Beyond this main task list, your app might support separate lists (e.g., 'Shopping', 'Book List'). Check for options to add or switch lists in the UI.",
        isNew: true,
      },
    ],
  },
  {
    name: "Power-Up Your Productivity with Timers",
    notes:
      "Many tasks have built-in timers. Default duration can be set in Settings.",
    isNew: true,
    children: [
      {
        name: "Focus with Task Timers",
        duration: 1500, // 25 minutes
        remaining: 1500,
        paused: true,
        notes:
          "Assign a duration and use play/pause. This task has a 25-min timer. The 'autoCompleteOnTimer' setting in general settings can mark tasks done when timer ends.",
        isNew: true,
      },
    ],
  },
  {
    name: "Conquer Chores with Daily Tasks (if 'Use Daily Tasks' is enabled)",
    notes:
      "Automate routines! If 'Use Daily Tasks' is on in Settings, define tasks that appear automatically.",
    isNew: true,
    children: [
      {
        name: "Daily Task Instance: 'Review Goals'",
        isDaily: true,
        dailyTaskId: "sample_daily_goals_id",
        notes:
          "This task is an example of an instance generated from a 'Daily Task' definition. You'd define the original (e.g., 'Review Goals' - its recurrence, duration, tags) in a 'Daily Tasks' section.",
        isNew: true,
      },
      {
        name: "Track Streaks for Daily Tasks",
        notes:
          "Completing daily tasks (like the one above) consistently builds a streak! This is usually tracked on the original daily task definition.",
        isNew: true,
      },
    ],
  },
  {
    name: "Customize Your App Experience via Settings",
    isNew: true,
    children: [
      {
        name: "Toggle Features & UI Elements",
        notes:
          "In Settings (often a gear icon), you can often enable/disable features like Notes, Tags, Priority, Daily Tasks, World Clocks, and UI elements like the Legend or keeping the drawer open.",
        isNew: true,
      },
      {
        name: "Other Handy Settings",
        notes:
          "Also in Settings: configure 'Add Task on Enter', 'Save on Browser Close', World Clock format, default task durations, and more!",
        isNew: true,
      },
      {
        name: "Data Management: Save All & Import",
        notes:
          "Your data is saved in the browser. Use 'Save All' in Settings to download a backup JSON. You can also import data from such a file.",
        isNew: true,
      },
    ],
  },
  {
    name: "Your Turn to Take Control!",
    notes: "You've seen the tour! Now, make this app your own.",
    isNew: true,
    children: [
      { name: "Try editing the title of THIS subtask.", isNew: true },
      { name: "Add your very first REAL main task to your list.", isNew: true },
      { name: "When comfortable, delete these sample tasks.", isNew: true },
    ],
  },
];
